<template>
    <div>
        <c-loader class="m-2" v-if="isLoading" :loader="isLoading" />
        <iframe
            class="custom-iframe"
            :src="url"
            @load="onIframeLoadedHandler"
            v-show="!isLoading"
        />
    </div>
</template>

<script>
import CLoader from '@/views/components/loader'
export default {
    name: 'Dashboard',
    props: ['url'],
    components: {
        CLoader,
    },
    data() {
        return {
            isLoading: true,
        }
    },
    methods: {
        onIframeLoadedHandler() {
            this.isLoading = false
        },
    },
    watch: {
        url() {
            this.isLoading = true
        },
    },
}
</script>

<style>
.custom-iframe {
    width: 100%;
    height: calc(100vh - 55px - 70px - 6px - 50px);
    border: none;
}
</style>
